import React from 'react';

import { useGridFilter } from 'ag-grid-react';
import { Button } from 'antd';
import 'common/components/ag-grid/FilterActions.less';

// Button bar only (never active); registered so the reactive filter wrapper has its callbacks
const passAll = () => true;

export default function ApplyFilter(event) {
  useGridFilter({ doesFilterPass: passAll });

  const handleApply = async () => {
    const key = event?.colDef?.field;
    const filter = await event?.api?.getColumnFilterInstance(key);
    filter?.applyModel();
    event?.api?.onFilterChanged();
    event?.api?.hidePopupMenu();
  };
  const handleReset = async () => {
    const key = event?.colDef?.field;
    const filter = await event?.api?.getColumnFilterInstance(key);
    filter?.setModel(undefined);
    filter?.applyModel();
    event?.api?.onFilterChanged();
    event?.api?.hidePopupMenu();
  };
  return (
    <div className='ag-grid-filter-actions'>
      <Button type='primary' onClick={handleApply}>
        Apply
      </Button>
      <Button onClick={handleReset}>Reset</Button>
    </div>
  );
}
